// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"67":"supplier","187":"search","275":"article","884":"admin"}[chunkId] + "." + {"67":"1e7a3ebc","187":"f426d447","275":"56e3482f","884":"8439fac9"}[chunkId] + ".js";
};